var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tz-tips",on:{"click":function($event){_vm.showTips = !_vm.showTips},"mouseenter":function($event){_vm.showTips = true},"mouseleave":function($event){_vm.showTips = false}}},[_vm._v("\n    "+_vm._s(_vm.short)+"\n    "),(_vm.showTips)?_c('div',{staticClass:"tz-tip"},[_vm._v(_vm._s(_vm.whole))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6598afb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tips.vue
// module id = null
// module chunks = 